<template lang="pug">
div.reunion
	.photos
		a(:href="image1", target="_blank")
			img(:src="image1", height="350px")
		a(:href="image2", target="_blank")
			img(:src="image2", height="350px")
		a(:href="image3", target="_blank")
			img(:src="image3", height="350px")
	.zipfiles
		a(href="./CB_Reunion_1.zip", target="_blank", download)
			small Click to download
			br
			span Reunion Photos 1
			br
			small 22.2 MB
		a(href="./CB_Reunion_2.zip", target="_blank", download)
			small Click to download
			br
			span Reunion Photos 2
			br
			small 23.9 MB
		a(href="./CB_Reunion_3.zip", target="_blank", download)
			small Click to download
			br
			span Reunion Photos 3
			br
			small 19.7 MB
	.video
		h3 Welcome Video
		video(width="480", height="848", controls)
			source(:src="video", type="video/mp4")
</template>

<script>

export default {
	name: 'Reunion',
	components: {
	},
	data () {
		return {
		}
	},
	computed: {
		video () {
			return require('../assets/welcomevideo.mp4')
		},
		image1 () {
			return require('../assets/CBEastDeceased52122.jpg')
		},
		image2 () {
			return require('../assets/CBWestDeceased52122.jpg')
		},
		image3 () {
			return require('../assets/classpicture.jpg')
		}
	}
}
</script>


<style lang="stylus" scoped>
.reunion
	margin-bottom 2px
	.video
		text-align center
		margin 0 auto
	.photos
		display flex
		justify-content space-between
		margin-bottom 40px
	.zipfiles
		display flex
		justify-content space-between
		margin-bottom 40px
		a
			display block
			border 2px solid lighten(#4287f5,10%)
			border-radius 6px
			padding 10px 20px
			color #2c3e50
			text-decoration none
			text-align center
			&:hover
				border-color darken(#4287f5, 10%)
				background-color #f4f4f4
</style>